<p-select
  [options]="countries"
  [(ngModel)]="selectedCountry"
  optionLabel="name"
  placeholder="Select a Country"
  (onChange)="changeLanguage($event)"
>
  <ng-template pTemplate="selectedItem">
    @if (selectedCountry) {
    <div class="selected-language">
      <img
        src="../../../assets/images/flag_placeholder.png"
        [class]="'flag flag-' + selectedCountry.code.toLowerCase()"
        style="width: 18px"
        alt="flag"
      />
      <div>{{ selectedCountry.name }}</div>
    </div>
    }
  </ng-template>
  <ng-template let-country pTemplate="item">
    <div class="selected-language">
      <img
        src="../../../assets/images/flag_placeholder.png"
        [class]="'flag flag-' + country.code.toLowerCase()"
        style="width: 18px"
        alt="flag"
        />
      <div>{{ country.name }}</div>
    </div>
  </ng-template>
</p-select>
